import { createSlice } from "@reduxjs/toolkit";

export const salesChannelsListSlice = createSlice({
  name: 'salesChannelsList',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startSalesChannelsList: (state) => { state.isLoading = true },
    setSalesChannelsList: (state, { payload: { data, error }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startSalesChannelsList, setSalesChannelsList } = salesChannelsListSlice.actions;

export  default salesChannelsListSlice;
